
<script>
export default class EnemyShip{
  constructor(_enemySprite, _enemyXCoord, _enemyYCoord, _enemyType, _enemySpeed, _chanceToFire) {
    // enemy types:
    // 0) shooter ship
    // 1) X-axis cutoff ship
    this.enemyType = _enemyType;

    this.enemySprite = _enemySprite //enemy sprite
    this.enemySpeed = _enemySpeed; //how fast enemy can move in each direction every 1/50s
    this.enemyCoords = [_enemyXCoord,_enemyYCoord];
    this.chanceToFire = _chanceToFire; //_chanceToFire/1.0 chance enemy fires every 1/10s
    this.hit = false; //if bullet hits this enemy, this flag is to be set to true
    this.postHitCountdown = 100; //how many 1/100s should enemy stay on screen before being deleted
  }
}
</script>
